module.exports = __webpack_public_path__ + "img/call_24px.1c689c85.svg";